import { useEffect, useState } from 'react';

import { Col, Footer, Picture, Row, Button, Banner, Typography } from 'darrius';

import { Header } from '../../components/atoms';
import { HeadContent } from '../../components';

import { type ISignupSuccessTemplateProps } from './@interfaces';

import styles from './SignupSuccessTemplate.module.scss';

export default function SignupSuccessTemplate({
  staticContent,
  deep_link,
}: ISignupSuccessTemplateProps) {
  const { footerContent } = staticContent;
  const [isMobile, setIsMobile] = useState(true);

  useEffect(() => {
    setIsMobile(navigator.userAgent.includes('Mobile'));
  }, []);

  return (
    <>
      <HeadContent
        metaTitle="GetNinjas | Orçamento de Profissionais Confiáveis no GetNinjas.com.br"
        slug="Anuncie"
        metaDescription="Encontre profissionais confiáveis para pintar, reformar, traduzir um texto, te ensinar matemática, ou também passear com seu cachorro no GetNinjas"
        type="page:register-full-success"
      />

      <Header.Simple />

      <main className="register-success space-top space-bottom">
        <Banner>
          <Row className="center-sm">
            <Col className="col-sm-5 col-md-2">
              <Picture
                className="full"
                src={{
                  sm: `${process.env.NEXT_PUBLIC_ASSETS_PREFIX}/images/rocket-success.svg`,
                  md: `${process.env.NEXT_PUBLIC_ASSETS_PREFIX}/images/rocket-success.svg`,
                  lg: `${process.env.NEXT_PUBLIC_ASSETS_PREFIX}/images/rocket-success.svg`,
                }}
              />
            </Col>
          </Row>
          <Row className="center-sm space-between">
            <Col className="col-sm-12 col-md-6">
              <Typography.Title size="3xl">
                Pronto, conta criada com sucesso!
              </Typography.Title>
              <Typography.Text className={styles.text}>
                Você está a um passo de ter mais clientes todos os dias. Faça o
                download do aplicativo e comece já!
              </Typography.Text>
            </Col>

            <Col className="col-sm-12">
              {isMobile ? (
                <Button.Link href={deep_link} size="small">
                  Fazer download do aplicativo
                </Button.Link>
              ) : (
                <img
                  src={`${process.env.NEXT_PUBLIC_ASSETS_PREFIX}/images/QR-code-download-app.png`}
                  width="230"
                  alt="QR Code para download do aplicativo getninjas"
                />
              )}
            </Col>

            <Col className="col-sm-12">
              <Button.Link
                href="/seja-um-profissional/cadastro"
                variation="clear"
                size="small"
              >
                Voltar para página inicial
              </Button.Link>
            </Col>
          </Row>
        </Banner>
      </main>

      <Footer data={footerContent} />
    </>
  );
}
